module.exports = __webpack_public_path__ + "img/Thanks-quotazione.3bf4016a.png";